//import components
import mainnav from '@/components/_globals/mainnav/mainnav.vue'

//import articles
import news from '@/assets/json/news/news.json'
import categories from '@/assets/json/news/categories.json'
export default {
  name: 'news',
  components: {
    mainnav
  },
  data: function () {
    return {
     leftDivider: null,
     rightDivider: null,
     currentCategory: null,
     isActive: true
    }
  },
  computed: {
    currentLocale: function() {
      return this.$i18n.locale
    },
    getCategories: function() {
      return categories
    },
    getNews: function () {
      news.sort(function (a, b) {
        if (a.id < b.id) {
          return 1;
        }
        if (a.id > b.id) {
          return -1;
        }
        return 0;
      })
      //calculates whether even id news are left or right
      if ((news.length % 2) === 0) {
        this.leftDivider = true
        this.rightDivider = false
      } else {
        this.leftDivider = false
        this.rightDivider = true
      }
      return news
    }
  },
  methods: {
    setActiveCategory(id) {
      this.currentCategory = id
      id === null ? this.isActive = true : this.isActive = false

    },
    newDetails(news) {
      this.$emit('news-info-details', news)
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/news/news.js